import React from 'react';
import i18next from 'i18next';

function Symptoms() {
    return (
        <>
            {i18next.language === 'ar' ? (
                <>
                    <p>
                        تظهر أعراض اضطراب طيف التوحد عادة في عمر السنتين إلى
                        الثلاث سنوات.
                    </p>
                    <h3 id='title'>الأعراض الأساسية لاضطراب طيف التوحد</h3>
                    <h4 id='title'>صعوبات في التواصل والتفاعل الاجتماعي</h4>
                    <ul id='last'>
                        <li>
                            صعوبات في التواصل اللفظي وغير اللفظي، على سبيل
                            المثال
                            <ul>
                                <li>
                                    صعوبات في اللغة اللفظية
                                    <ul>
                                        <li>صعوبات في الكلام</li>
                                    </ul>
                                </li>
                                <li>
                                    صعوبات في اللغة غير اللفظية
                                    <ul>
                                        <li>
                                            صعوبات في فهم واستخدام الإيماءات
                                        </li>
                                        <li>صعوبات في التواصل البصري</li>
                                        <li>
                                            صعوبات في فهم واستخدام تعابير الوجه
                                            ونبرة الصوت.
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>
                            صعوبات في التفاعل الاجتماعي
                            <ul>
                                <li>صعوبات في التعرف على مشاعر الآخرين.</li>
                                <li>
                                    صعوبات في التعرف والتعبير عن عواطفه ومشاعره.
                                </li>
                                <li>صعوبات في الكلام بالدور أثناء المحادثة.</li>
                                <li>
                                    الشعور بالإرهاق الشديد في المواقف
                                    الاجتماعية.
                                </li>
                                <li>
                                    صعوبات في تحديد المسافة المناسبة بين الشخص
                                    ذو اضطراب طيف التوحد والآخرين.
                                </li>
                            </ul>
                        </li>
                    </ul>
                    <h4 id='title'>أنماط من السلوكيات التكرارية والمحدودة</h4>
                    <p id='list'>
                        تختلف أنماط السلوكيات المحدودة والتكرارية اختلافًا
                        كبيرًا بين الأشخاص ذوي اضطراب طيف التوحد حيث يمكن أن
                        تشمل:
                    </p>
                    <ul>
                        <li>
                            حركات الجسم المتكررة مثل (الدوران حول نفسه، رفرفة
                            اليدين، هز الجسم، الركض ذهابًا وإيابًا).
                        </li>
                        <li>
                            الحركات المتكررة بالمجسمات مثل (هز الأعواد، تحريك
                            عجلات السيارات، تقليب السيارات).
                        </li>
                        <li>
                            الطقوس في السلوكيات مثل: صف الأشياء (المجسمات) بشكل
                            معين، لمس الأشياء بشكل متكرر بترتيب محدد.
                        </li>
                        <li>اهتمامات محدودة في مواضيع معينة.</li>
                        <li id='last'>
                            الحاجة إلى نفس الروتين ومقاومة التغيير مثلًا: (نفس
                            الجدول اليومي، نفس قائمة الوجبات).
                        </li>
                    </ul>
                    <h4 id='title'>
                        المؤشرات المبكرة لخطر إصابة الأطفال باضطراب طيف التوحد
                    </h4>
                    <p id='list'>
                        بناءً على مركز التحكم بالأمراض والوقاية منها الإمريكي
                        (CDC) فإن المؤشرات المبكرة لخطر إصابة الأطفال باضطراب
                        طيف التوحد هي:
                    </p>
                    <ul>
                        <li>
                            في عمر ١٢ شهرًا الطفل لا يستجيب عند مناداته باسمه.
                        </li>
                        <li>
                            في عمر ١٤ شهرًا الطفل لا يؤشر بأصبعه إلى الأشياء.
                            ليظهر الاهتمام بها.
                        </li>
                        <li id='last'>
                            في عمر ١٨ شهرًا الطفل لا يلعب اللعب التخيلي.
                        </li>
                    </ul>
                    <h4 id='title'>
                        بعض من الأعراض العامة المبكرة لمؤشرات خطر الإصابة
                        باضطراب طيف التوحد
                    </h4>
                    <ul>
                        <li>يتجنب التواصل البصري ويرغب في الجلوس وحيداً.</li>
                        <li>
                            لديه مشكلة في فهم مشاعر الآخرين أو التحدث عن مشاعره.
                        </li>
                        <li>تأخر في مهارات اللغة والتخاطب.</li>
                        <li>يكرر الكلمات أو العبارات كثيراً (المصاداة).</li>
                        <li>يعطي إجابات ليس لها علاقة بالأسئلة.</li>
                        <li>ينزعج من التغييرات الصغيرة.</li>
                        <li>تعلق شديد باهتمامات معينة.</li>
                        <li>
                            لديه حركات متكررة مثل رفرفة اليدين، هز الجسم،
                            الدوران حول نفسه.
                        </li>
                        <li id='last'>
                            ردود أفعال غير عادية تجاه الأشياء من ناحية صوتها،
                            رائحتها، طعمها، شكلها، أو احساسها.
                        </li>
                    </ul>
                    <h3 id='title'>اضطرابات مصاحبة لاضطراب طيف التوحد</h3>
                    <p>
                        أكثر من نصف الأشخاص ذوي اضطراب طيف التوحد يعانون من
                        أربعة أو أكثر من الحالات المصاحبة للتوحد. تختلف أنواع
                        الحالات المصاحبة للتوحد وكيفية ظهورها من شخص لآخر.{' '}
                    </p>
                    <h4 id='title'>
                        الاضطرابات الشائعة المصاحبة لاضطراب طيف التوحد
                    </h4>
                    <p id='list'>
                        بشكل عام إن الاضطرابات التي تتداخل مع التوحد تندرج إلى
                        أربعة أقسام:
                    </p>
                    <ol>
                        <li>
                            الحالات الطبية مثل: الصرع، مشاكل الجهاز الهضمي، و
                            اضطرابات النوم.
                        </li>
                        <li>
                            الاضطرابات النمائية مثل: الإعاقة العقلية، و التأخر
                            في اللغة.
                        </li>
                        <li>
                            الاضطرابات النفسية مثل: اضطراب فرط الحركة وتشتت
                            الانتباه (ADHD)، اضطراب الوسواس القهري، والاكتئاب.
                        </li>
                        <li id='last'>
                            الاضطرابات الوراثية مثل: متلازمة كروموسوم إكس الهش،
                            و التصلب الحدبي المعقد.
                        </li>
                    </ol>
                    <p>
                        علاج الاضطرابات المصاحبة للتوحد مهم، لأنه قد يساعد في
                        تخفيف أعراض اضطراب طيف التوحد وبالتالي تحسين جودة حياة
                        الأفراد ذوي اضطراب طيف التوحد. مثلًا: علاج مشاكل النوم،
                        يكون له فوائد سلوكية بحيث يمكن أن يؤثر عدد ساعات النوم
                        وجودة النوم على الحالة المزاجية للفرد ذو اضطراب طيف
                        التوحد وعلى شدة السلوكيات التكرارية لديه.
                    </p>
                </>
            ) : (
                <>
                    <p>Signs of autism usually appear by age 2 or 3.</p>
                    <h3 id='symptoms-of-autism'>Symptoms of Autism</h3>
                    <h4 id='difficulty-with-verbal-and-non-verbal-communication-and-social-interactions'>
                        Difficulty with verbal and non-verbal communication and
                        Social interactions
                    </h4>
                    <ul>
                        <li>
                            Difficulty with verbal and non-verbal communication.
                            For example, they may not understand or
                            appropriately use:
                            <ul>
                                <li>
                                    Spoken language (around a third of people
                                    with autism are nonverbal)
                                </li>
                                <li>
                                    Spoken language (around a third of people
                                    with autism are nonverbal)
                                </li>
                                <li>Gestures</li>
                                <li>Eye contact</li>
                                <li>Facial expressions and tone of voice</li>
                            </ul>
                        </li>
                        <li>
                            Social challenges can include difficulty with:
                            <ul>
                                <li>
                                    Recognizing emotions and intentions in
                                    others
                                </li>
                                <li>Recognizing one’s own emotions</li>
                                <li>Expressing emotions</li>
                                <li>
                                    Feeling overwhelmed in social situations
                                </li>
                                <li>Taking turns in conversation</li>
                            </ul>
                        </li>
                    </ul>
                    <h4 id='restricted-and-repetitive-behaviors'>
                        Restricted and repetitive behaviors
                    </h4>
                    <p>
                        Restricted and repetitive behaviors vary greatly across
                        the autism spectrum. They can include:
                    </p>
                    <ul>
                        <li>
                            Repetitive body movements (e.g. rocking, flapping,
                            spinning, running back and forth){' '}
                        </li>
                        <li>
                            Repetitive motions with objects (e.g. spinning
                            wheels, shaking sticks, flipping levers)
                        </li>
                        <li>
                            Ritualistic behaviors (e.g. lining up objects,
                            repeatedly touching objects in a set order)
                        </li>
                        <li>Narrow or extreme interests in specific topics</li>
                        <li>
                            Need for unvarying routine/resistance to change
                            (e.g. same daily schedule, meal menu, clothes, route
                            to school)
                        </li>
                    </ul>
                    <p>
                        According to the Centers for Disease Control and
                        Prevention:{' '}
                    </p>
                    <h4 id='red-flags-early-symptoms-of-autism'>
                        Red Flags: Early Symptoms of Autism
                    </h4>
                    <ul>
                        <li>By 12 months … Does not respond to name</li>
                        <li>
                            By 14 months... Does not point at objects to show
                            interest
                        </li>
                        <li>By 18 months... Does not pretend play</li>
                    </ul>
                    <h4 id='general-symptoms-'>General Symptoms:</h4>
                    <ul>
                        <li>Avoids eye contact and may want to be alone</li>
                        <li>
                            Has trouble understanding other people’s feelings or
                            talking about their own feelings
                        </li>
                        <li>Has delayed speech and language skills</li>
                        <li>
                            Repeats words or phrases over and over (echolalia)
                        </li>
                        <li>Gives unrelated answers to questions</li>
                        <li>Gets upset by minor changes</li>
                        <li>Has obsessive interests</li>
                        <li>
                            Makes repetitive movements like flapping hands,
                            rocking, or spinning in circles
                        </li>
                        <li>
                            Has unusual reactions to the way things sound,
                            smell, taste, look, or feel
                        </li>
                    </ul>
                    <h3 id='conditions-that-accompany-autism'>
                        Conditions that Accompany Autism
                    </h3>
                    <p>
                        More than half of people on the spectrum have four or
                        more other conditions. The types of co-occurring
                        conditions and how they manifest varies from one person
                        with autism to the next.{' '}
                    </p>
                    <h4 id='conditions-that-overlap-with-autism'>
                        Conditions that overlap with autism
                    </h4>
                    <p>
                        The conditions that overlap with autism generally fall
                        into one of four groups:
                    </p>
                    <ol>
                        <li>
                            Classic medical problems, such as epilepsy,
                            gastrointestinal issues or sleep disorders
                        </li>
                        <li>
                            Developmental diagnoses, such as intellectual
                            disability or language delay
                        </li>
                        <li>
                            Mental-health conditions, such as attention deficit
                            hyperactivity disorder (ADHD), obsessive-compulsive
                            disorder or depression
                        </li>
                        <li>
                            Genetic conditions, including fragile X syndrome and
                            tuberous sclerosis complex.
                        </li>
                    </ol>
                    <p>
                        Resolving these conditions could help to improve the
                        quality of life for people with autism .For example,
                        Sleep quantity and quality can affect mood and the
                        severity of repetitive behaviors.{' '}
                    </p>
                </>
            )}
        </>
    );
}

export default Symptoms;
